const FlagDE = props => (
	<svg height="28" viewBox="0 0 200 200" width="28" {...props}>
		<rect fill="#434a54" width="200" height="66.67" />
		<rect fill="#ed5565" y="66.67" width="200" height="66.67" />
		<rect fill="#ffce54" y="133.33" width="200" height="66.67" />
	</svg>
);

export default FlagDE;
